<div class="mydocma-dialog mydocma-dialog-xs-fullscreen">

  <div class="mydocma-dialog-container">
    <div
      #headerRef
      class="mydocma-dialog-header pane-header">
      <div class="mydomca-dialog-header-title">{{ (structure?.Name1 + (structure?.Name2 != null ? ' - ' : '') + structure?.Name2) }}</div>

      <button *ngIf="dialogMode" mat-icon-button mat-dialog-close (click)="closeByCode()">
        <mat-icon style="margin-right: 0px; color: currentColor">close</mat-icon>
      </button>
      <button *ngIf="!dialogMode" mat-icon-button (click)="closeByCode()">
        <mat-icon style="margin-right: 0px; color: currentColor">close</mat-icon>
      </button>
    </div>

    <div class="mydocma-dialog-body" [class.mydocma-dialog-body-with-expand]="hasExtendedAddressData && !appContainerService.isMobileView">

      <div *ngIf="(addresses?.length ?? 0) === 0" class="no-addresses-in-project">
        {{'MM.structureAddressInfo.noAddressesInProjectLabel' | translate }}
      </div>

      <div class="address-content" [class.address-content-not-expanded]="!isExpanded" *ngIf="(addresses?.length ?? 0) > 0">
        <div class="address-container" [class.last-address-container]="last" *ngFor="let address of addresses; let last = last">

          <div class="address-type">{{ (address.AddressType === addressTypes.Renter ? 'MM.structureAddressInfo.addressTypeRenter' : (address.AddressType === addressTypes.Owner ? 'MM.structureAddressInfo.addressTypeOwner' : 'MM.structureAddressInfo.addressTypePropertyManager')) | translate }}</div>

          <div class="address-columns" style="display: flex; flex-direction: row; gap: 12px;">
            <div class="address-column-left" [class.address-column-left-expanded]="isExpanded">
              <div class="address-left-extended-container" [class.address-column-left-expanded]="isExpanded">

                <div *ngIf="(address.Address.Salutation ?? '') != '' || (address.Address.DisplayName ?? '') != ''" class="address-field">{{ ((address.Address.Salutation ?? '') + ' ' + (address.Address.DisplayName ?? '')).trim() }}</div>
                <div *ngIf="(address.Address.Street ?? '') != ''" class="address-field">{{ address.Address.Street }}</div>
                <div *ngIf="(address.Address.City ?? '') != ''" class="address-field">{{ address.Address.City }}</div>
                <div *ngIf="(address.Address.Phone ?? '') != '' || (address.Address.Mobile ?? '') != ''" class="address-field">{{ address.Address.Phone ?? address.Address.Mobile }}</div>
                <div *ngIf="(address.Address.Email ?? '') != ''" class="address-field">{{ address.Address.Email }}</div>

                <div *ngIf="appContainerService.isMobileView && (address.Address.Fax ?? '') != ''" class="address-field">{{ address.Address.Fax }}</div>
                <div *ngIf="appContainerService.isMobileView && (address.Address.Text1 ?? '') != ''" class="address-field">{{ address.Address.Text1 }}</div>
                <div *ngIf="appContainerService.isMobileView && (address.Address.Text2 ?? '') != ''" class="address-field">{{ address.Address.Text2 }}</div>
                <div *ngIf="appContainerService.isMobileView && address.Address.User?.Id != null" class="address-field">{{ address.Address.User?.Account }}</div>

              </div>

            </div>
            <div class="address-column-right" *ngIf="isExpanded && hasExtendedAddressData && !appContainerService.isMobileView">
              <div class="address-right-extended-container">
                <div *ngIf="(address.Address.Fax ?? '') != ''" class="address-field">{{ address.Address.Fax }}</div>
                <div *ngIf="(address.Address.Text1 ?? '') != ''" class="address-field">{{ address.Address.Text1 }}</div>
                <div *ngIf="(address.Address.Text2 ?? '') != ''" class="address-field">{{ address.Address.Text2 }}</div>
                <div *ngIf="address.Address.User?.Id != null" class="address-field">{{ address.Address.User?.Account }}</div>
              </div>
            </div>
          </div>

          <div *ngIf="!last" class="address-divider"></div>

        </div>
      </div>
      <div class="address-expand-container" *ngIf="hasExtendedAddressData && !appContainerService.isMobileView">
        <div class="address-expand-icon-container">
          <mydocma-custom-mat-icon [iconName]="'_double_arrow'" class="address-expand-icon" (click)="toggleExpanded()" *ngIf="!isExpanded"></mydocma-custom-mat-icon>
          <mydocma-custom-mat-icon [iconName]="'_double_arrow'" class="address-expand-icon" style="transform: scaleX(-1)" (click)="toggleExpanded()" *ngIf="!!isExpanded"></mydocma-custom-mat-icon>
        </div>
      </div>

    </div>
  </div>
</div>
